import type { ReactNode } from 'react';
import styled from 'styled-components';
import type { Columns } from './SimpleTable';
import { getIterativeProps } from './utils';

const StyledMobileRowItem = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: auto;
	gap: 0.5rem;

	justify-items: start;
	align-items: center;
`;

type Props = {
	columns: Columns;
	record: any;
};

export const DefaultMobileRowItem = ({ columns, record }: Props) => (
	<StyledMobileRowItem>
		{columns.map((column, index) => {
			const data = getIterativeProps(record, column.dataIndex);

			return (
				// eslint-disable-next-line react/no-array-index-key
				<span key={String(index)}>
					{column?.render ? (column.render(data, record, index) as ReactNode) : data}
				</span>
			);
		})}
	</StyledMobileRowItem>
);
